import _ from 'lodash';
import { useState, useEffect, useRef } from 'react';
import { Grid, Stepper, Step, StepLabel, Button, Modal, Box } from '@mui/material';
// import { StyledEngineProvider } from '@mui/material/styles';
import axios from 'axios';
import * as Icons from '@material-ui/icons';

import FormRenderer from '../../components/FormRenderer';
import { useCheckRequired } from '../../functions/helperfunctions/ticketDataCheckFunctions';
// import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
// import { act } from 'react-dom/test-utils';

function TicketForm({ formData, parts, url, formKey, formId }) {
	const [activeStep, setActiveStep] = useState(0);
	const [checkStep, setCheckStep] = useState(null);
	const [data, setData] = useState(formData);
	const formParts = parts; // Drin lassen -> sind für die Javascripts in den Formularen

	// Defaultwerte einlesen und in die ticketData speichern
	const defaultData = {};
	data?.data?.forEach(page =>
		page?.data?.forEach(part => {
			// Defaultwert einfügen
			if (part?.config?.['external']?.default) {
				//data[part.id] = part?.config?.['external']?.default;
				defaultData[part.id] = part?.config?.['external']?.default;
			}
		})
	);

	const [errorElements, setErrorElements] = useState({});
	const [ticketData, setTicketData] = useState(defaultData);
	const [stepComplete, setStepComplete] = useState(false);
	const [openModal, setOpenModal] = useState(false); // Modal zum Senden
	const [openModalSuccess, setOpenModalSuccess] = useState(false); // Modal Erfolgreich
	const [openModalSuccessAttachments, setOpenModalSuccessAttachments] = useState(false); // Modal Erfolgreich aber Attachments-Problem
	const [openModalError, setOpenModalError] = useState(false); // Modal-Fehler anzeigen
	const [openModalSendError, setOpenModalSendError] = useState(false); // Modal Fehler im Backend
	const oldStateTicketData = useRef(null); // Speichern den vorherigen Stand von ticketData

	// Die Maximale/Minimale Länge eines Felder überprüfen. Rückgabe True wenn alles eingehalten wurde. Sonst False.
	// const checkIsInMaxLength = UseCheckIsInMaxLength(ticketData, parts);

	// Prüfen ob auf der aktuellen Seite alle "required" erfüllt sind.
	const checkRequired = useCheckRequired(
		data,
		parts,
		activeStep,
		ticketData,
		(part, id) => setErrorElements(prevState => ({ ...prevState, [part]: { ...(prevState[part] || {}), [id]: true } })),
		(part, id) => setErrorElements(prevState => ({ ...prevState, [part]: { ...(prevState[part] || {}), [id]: false } }))
	);

	// Eigenes JS aus dem Formular einbinden um ticketData zu verändern
	useEffect(() => {
		setStepComplete(checkRequired(checkStep, false));
		if (data.data[0]?.ticketDataScript) {
			try {
				eval(data.data[0]?.ticketDataScript);
			} catch (e) {
				console.log('Error!: ', e);
			}
		}
	}, [JSON.stringify(ticketData), activeStep]);

	// Script für die Logiken im Formular ausführen
	useEffect(() => {
		// Nur ausführen wenn sich ticketData geändert hat und logics auch da sind
		if (data?.data?.[0]?.logics) {
			setTicketData(prevState => {
				const editData = Object.assign({}, prevState);

				// Sichtbarkeit
				if (data?.data?.[0]?.logics?.visibility) {
					const rules = data?.data?.[0]?.logics?.visibility;

					function initStructure(name) {
						if (!editData[name]) editData[name] = {};
						display(name, false);
					}
					function display(name, value) {
						editData[name]['display'] = value;
					}
					rules.forEach(element => {
						initStructure(element.part || []);
					});

					rules.forEach(element => {
						const showItem = element?.conditions.every(cond => {
							const formItem = data?.['data']?.flatMap(page => page?.data).find(item => item.id === cond.trigger);
							const searchPart = formParts?.[formItem?.part]?.['external'].flatMap(ext => ext.id);
							if (Array.isArray(cond.triggerValues)) {
								return cond?.triggerValues?.some(el => ticketData?.[cond.trigger]?.[searchPart]?.includes(el));
							} else {
								return cond?.triggerValues === ticketData?.[cond.trigger]?.[searchPart];
							}
						});
						if (showItem) {
							display(element?.part, element?.setTo);
						}
					});
				}

				return editData;
			});

			setData(prevState => {
				const editFormData = Object.assign({}, prevState);

				// Größe
				if (data?.data?.[0]?.logics?.size) {
					const rules = data?.data?.[0]?.logics?.size;
					rules.forEach(element => {
						const stretchItem = element?.conditions.every(cond => {
							const formItem = data?.['data']?.flatMap(page => page?.data).find(item => item.id === cond.trigger);
							const searchPart = formParts?.[formItem?.part]?.['external'].flatMap(ext => ext.id);
							if (Array.isArray(cond.triggerValues)) {
								return cond?.triggerValues?.some(el => {
									return ticketData?.[cond.trigger]?.[searchPart]
										? ticketData?.[cond.trigger]?.[searchPart]?.includes(el)
										: el === cond.defaultValue
								});
							} else {
								return (
									cond?.triggerValues ===
									(ticketData?.[cond.trigger]?.[searchPart] !== undefined
										? ticketData?.[cond.trigger]?.[searchPart]
										: cond.defaultValue)
								);
							}
						});
						editFormData.data.forEach((page, index) => {
							page.data.forEach((parte, index2) => {
								if (element.part === parte.id) {
									if (stretchItem) {
										editFormData.data[index].data[index2]['config']['grid'] = element.setTo;
									} else {
										editFormData.data[index].data[index2]['config']['grid'] = element.elseTo; 
									}
								}
							});
						});
					});
				}

				// Optionen
				if (data?.data?.[0]?.logics?.options) {
					const rules = data?.data?.[0]?.logics?.options;
					rules.forEach(elm => {
						const formItem = data?.['data']?.flatMap(page => page?.data).find(item => item.id === elm.trigger);
						const searchPart = formParts?.[formItem?.part]?.['external'].flatMap(ext => ext.id);
						const triggerValSelected = ticketData?.[elm.trigger]?.[searchPart];
						const triggerOptions =
							rules
								?.find(item => item?.part === elm?.part)
								?.['conditions']?.find(area => area?.['triggerValues']?.includes(triggerValSelected))?.options || [];
						editFormData?.data?.forEach((page, index) => {
							page?.data?.forEach((part, index2) => {
								if (part.id === elm?.part) {
									editFormData.data[index].data[index2]['config']['options'] = triggerOptions;
								}
							});
						});
					});
				}
				return editFormData;
			});
		}
	}, [JSON.stringify(ticketData), activeStep, data?.data?.[0]?.logics]);

	const sendTicket = async () => {
		try {
			//setSendTicketLoading(true);
			setOpenModal(true);

			let formData = new FormData();
			formData.append('id', formId);
			formData.append('key', formKey);

			const flattendForm = _.flatten(data?.data.map(e => e.data));
			const parsedData = _.mapValues(ticketData, (value, key) => {
				// Für alle Datei-Upload Felder werden der Name und Dateityp aus dem File-Objekt extrahiert und gesondert übertragen
				if (flattendForm.find(e => e.id === key)?.part === 'files') {
					value?.files?.map(e => formData.append(key, e));
					return { files: value?.files?.map(e => ({ file: e, name: e.name, type: e.type })) };
				}
				// Alle anderen Daten werden unverändert übertragen
				return value;
			});
			formData.append('data', JSON.stringify(parsedData));
			const response = await axios.post(`${url}/new`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			// Prüfen ob das Senden erfolgreich war
			if (response?.status === 200) {
				setOpenModal(false);
				if (response?.data?.error) {
					// Ein Fehler ist aufgetreten.
					setOpenModalSendError(true);
				} else {
					if (response?.data?.attachmentError) {
						setOpenModalSuccessAttachments(true);
					} else {
						setOpenModalSuccess(true);
					}
					// Daten löschen
					setTicketData({});
					setActiveStep(0);
					setCheckStep(null);
				}
			}
		} catch (error) {
			//setSendTicketLoading(false);
			setOpenModal(false);
		}
	};

	const handleNext = () => {
		// Weiter/Absendebutton wurde gedrückt!
		setCheckStep(activeStep);

		// Prüfen der Pflichtfelder
		if (!checkRequired(activeStep, true)) {
			// Ausgabe das Pflichtfelder fehlen oder Felder nicht korrekt ausgefüllt wurden
			setOpenModalError(true);
			return;
		}

		// Absenden oder nächster Schritt
		if (activeStep === data?.['data']?.length - 1) return sendTicket();
		setCheckStep(null);
		setActiveStep(activeStep + 1);
	};

	const handleBack = () => {
		// if (activeStep === 0 && forms.length > 1) return dispatch(setForm(null));
		if (activeStep > 0) setActiveStep(activeStep - 1);
	};

	const onChange = (value, part, id, formularData, partData) => {
		setTicketData(prevState => ({ ...prevState, [part]: { ...prevState[part], [id]: value } }));
	};

	const style = {
		'&': { fontSize: '14px', textAlign: 'left' },
		'& .meldooHeaderBlock': { fontWeight: 'bold', color: 'black' },
		'& .meldooTextInput, .meldooEmailInput, .meldooSelectInput, .meldooAutoSelectInput, .meldooTextareaInput': {
			fontSize: '14px',
			color: 'black',
			borderRadius: '4px'
		},
		'& .meldooTextInputLabel, .meldooEmailInputLabel, .meldooSelectInputLabel, .meldooAutoSelectInputLabel, .meldooTextareaLabel, .meldoofilesInputLabel, .meldooCheckBoxLabel': {
			fontSize: '14px'
			//      color: 'purple'
		},
		'& .MuiButton-contained': {
			backgroundColor: '#337ab7',
			color: 'white',
			borderRadius: '2px'
		},
		'& Button:hover': {
			backgroundColor: '#165d9a',
			color: 'white'
		},
		modal: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			width: 400,
			bgcolor: 'background.paper',
			border: '2px solid #000',
			borderRadius: '2px',
			boxShadow: 24,
			p: 4,
			button: {
				marginTop: '10px',
				float: 'right',
				backgroundColor: '#337ab7',
				color: 'white',
				borderRadius: '2px'
			}
		},
		'& .MuiOutlinedInput-notchedOutline': {
			color: 'grey !important',
			borderColor: 'grey !important'
		},
		'& .Mui-error, .Mui-error .MuiOutlinedInput-notchedOutline': {
			color: '#CA340F !important',
			borderColor: '#CA340F !important'
		},
		'& a': {
			color: '#165d9a'
		},
		'& a:hover': {
			textDecoration: 'underline'
		},
		'& .MuiAutocomplete-clearIndicator, .MuiAutocomplete-popupIndicator': { backgroundColor: '#aaaaaa' },
		'& .MuiAutocomplete-clearIndicator:hover, .MuiAutocomplete-popupIndicator:hover': { backgroundColor: '#555555' }
	};

	const sendButton = data?.['data'][0]?.sendButton;
	const nextButton = data?.['data'][0]?.nextButton;
	const backButton = data?.['data'][0]?.backButton;
	const buttonValue = activeStep === data?.['data']?.length - 1 ? sendButton?.text || 'Absenden' : nextButton?.text || 'Weiter';
	const ButtonSendNext = activeStep === data?.['data']?.length - 1 ? Icons[sendButton?.icon] : Icons[nextButton?.icon];
	const ButtonBack = Icons[backButton?.icon];

	//	className={(window.location.hostname === 'www.meldooplus.de' || window.location.hostname === 'localhost')}
	return (
		<Box sx={style}>
			{/* <Button variant="contained" onClick={() => setOpenModalSuccess(true)}>
        Open modal
      </Button>
      <Button variant="contained" onClick={() => resetForm()}>
        Reset Form
      </Button>
       */}
			{/* <Button variant="contained" onClick={() => consoleLogData()}>
        Console-Log
      </Button> */}
			<Modal open={openModal} onClose={() => setOpenModal(false)}>
				<Box className="meldooModal" sx={style.modal}>
					Sende Daten...
				</Box>
			</Modal>
			<Modal open={openModalSuccess} onClose={() => setOpenModalSuccess(false)}>
				<Box className="meldooModal" sx={style.modal}>
					Ihre Daten wurden erfolgreich übertragen.
					<Button variant="contained" disableElevation onClick={() => setOpenModalSuccess(false)}>
						Schliessen
					</Button>
				</Box>
			</Modal>
			<Modal open={openModalSuccessAttachments} onClose={() => setOpenModalSuccessAttachments(false)}>
				<Box className="meldooModal" sx={style.modal}>
					Ihre Daten wurden erfolgreich übertragen.
					<br />
					Allerdings ist beim Hochladen ein Problem mit mindestens einer Datei aufgetreten die nicht gespeichert werden konnte.
					<Button variant="contained" disableElevation onClick={() => setOpenModalSuccessAttachments(false)}>
						Schliessen
					</Button>
				</Box>
			</Modal>

			<Modal open={openModalError} onClose={() => setOpenModalError(false)}>
				<Box className="meldooModal" sx={style.modal}>
					Bitte füllen Sie alle Pflichtfelder korrekt aus.
					<Button variant="contained" disableElevation onClick={() => setOpenModalError(false)}>
						OK
					</Button>
				</Box>
			</Modal>

			<Modal open={openModalSendError} onClose={() => setOpenModalSendError(false)}>
				<Box className="meldooModal" sx={style.modal}>
					Es ist ein Fehler beim anlegen des Tickets aufgetreten. Bitte versuchen Sie es später nochmal.
					<Button variant="contained" disableElevation onClick={() => setOpenModalSendError(false)}>
						OK
					</Button>
				</Box>
			</Modal>

			<Grid className="meldooGridRoot" container spacing={2}>
				<Grid className="meldooGridStep" item lg={12} md={12} sm={12} xs={12}>
					<Stepper activeStep={activeStep}>
						{data?.['data'].length > 1 &&
							data?.['data']?.map((page, index) => {
								return (
									<Step key={'step_' + index}>
										<StepLabel className="meldooGridStepName">{page.pageName}</StepLabel>
									</Step>
								);
							})}
					</Stepper>
				</Grid>
				{data.data[activeStep].data.map(part => (
					<FormRenderer
						partData={part}
						parts={parts}
						userData={ticketData}
						errorElements={errorElements}
						removeFile={() => null}
						onChange={onChange}
					/>
				))}

				<Grid className="meldooGridStepBack" item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="flex-start">
					{data?.['data'].length > 1 && activeStep > 0 && (
						<Button
							startIcon={ButtonBack ? <ButtonBack /> : <></>}
							variant="contained"
							color="inherit"
							onClick={handleBack}
							sx={{ mr: 1 }}
						>
							{backButton?.text || 'Zurück'}
						</Button>
					)}
				</Grid>
				<Grid className="meldooGridStepForward" item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="flex-end">
					<Button
						startIcon={ButtonSendNext ? <ButtonSendNext /> : <></>}
						variant={stepComplete ? 'contained' : 'outlined'}
						color={'inherit'}
						onClick={handleNext}
						style={{ margin: 0 }}
						sx={{ mr: 1 }}
					>
						{buttonValue}
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
}

export default TicketForm;
